<template>
  <div class="items-block">
    <v-row no-gutters>
      <v-col :cols="12" :md="items.length > 0 ? 4 : 12" class="item-list-wrap">
        <div class="summary">
          <div>
            We found {{ items.length }} {{ this.typeLabel }} for
            <a>{{ zipcode }}</a> ZipCode.
          </div>
        </div>
        <div v-if="items.length > 0" class="item-list" id="item-list">
          <div v-for="(item, index) in itemsWithMarkers" class="item"
            :class="{ 'item--active': selectedItem && selectedItem.RetailOrganizationID === item.RetailOrganizationID }"
            :key="item.RetailOrganizationID" :id="item.RetailOrganizationID">
            <v-row align="center">
              <v-col cols="1" class="d-none d-md-block">
                {{ index + 1 }}
              </v-col>
              <v-col>
                <div class="pl-2">
                  <div class="item__title"><strong>{{ item.StoreName }}</strong></div>
                  <a class="item__phone d-none d-md-inline-block" :href="'tel:' + item.StorePhone">{{ item.StorePhone
                  }}</a>
                  <div class="item__address">
                    {{ item.StoreAddressLine1 }}
                    {{ item.StoreAddressLine2 }}
                    {{ item.StoreCity }},
                    {{ item.StoreState }}
                    {{ item.StorePostalCode }}
                  </div>
                  <v-btn block color="black" class="item__btn d-md-none" :href="'tel:' + item.StorePhone"><v-icon color="white">{{ mdiPhone
                  }}</v-icon>
                    Call</v-btn>
                </div>
              </v-col>
              <v-col cols="auto" class="d-none d-md-block">
                <div class="align-center" v-if="item.hasMarker">
                  <v-icon color="primary lighten-2" @click="selectItem(item)">{{ mdiMap }}</v-icon>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col :cols="8" v-if="items.length > 0" class="d-none d-md-block">
        <div class="map-wrapper">
          <div class="show-all" v-if="selectedItem" @click="showAll">Show All</div>
          <GmapMap :options="mapOptions" :center="mapCenter" :zoom="8" class="map-container" ref="mapRef">
            <GmapMarker :key="index" v-for="(m, index) in filteredMarkers" :position="m.position" :clickable="true"
              @click="selectItem(m)"></GmapMarker>
          </GmapMap>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import tabTypes from "@/utils/tabTypes.js";
import { mdiMap, mdiPhone } from '@mdi/js'
export default {
  name: 'Distributors',
  props: {
    type: String,
    items: Array,
    zipcode: String | Number,
  },
  data() {
    return {
      mdiMap,
      mdiPhone,
      mapName: 'bigMap',
      mapOptions: {
        styles: [{
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{
            "lightness": 100
          }, {
            "visibility": "simplified"
          }]
        }, {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "visibility": "on"
          }, {
            "color": "#C6E2FF"
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#C5E3BF"
          }]
        }, {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#D1D1B8"
          }]
        }]
      },
      mapCenter: { lat: 34.0742387, lng: -118.3443005 },
      selectedItem: null,
      bounds: null,
    };
  },
  computed: {
    typeLabel: function () {
      return this.type === tabTypes.retail ? 'Retail Stores' : 'In Home Providers';
    },
    itemsWithMarkers: function () {
      return this.items.map((item) => {
        return {
          ...item,
          position: {
            lat: Number(item.Latitude),
            lng: Number(item.Longitude)
          },
          hasMarker: Number(item.Latitude) && Number(item.Longitude)
        };
      });
    },
    filteredMarkers: function () {
      return this.itemsWithMarkers.filter((item) => {
        return item.hasMarker;
      });
    }
  },
  watch: {
    filteredMarkers: {
      handler: function () {
        setTimeout(() => {
          if (this.filteredMarkers.length > 0) {
            this.$refs.mapRef.$mapPromise.then((map) => {
              this.bounds = this.filteredMarkers.reduce((bounds, marker) => {
                return bounds.extend(marker.position);
              }, new google.maps.LatLngBounds());
              map.setCenter(this.bounds.getCenter());
              map.fitBounds(this.bounds);
            });
          }
        }, 10);

      },
      immediate: true
    }
  },
  methods: {
    selectItem: function (item) {
      this.selectedItem = item;
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.setZoom(15);
        map.panTo(item.position);
      });
      this.scrollTo(document.getElementById('item-list'), document.getElementById(item.RetailOrganizationID));
    },

    showAll: function () {
      this.selectedItem = null;
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.setCenter(this.bounds.getCenter());
        map.fitBounds(this.bounds);
      });
    },

    scrollTo: function scrollParentToChild(parent, child) {
      const parentRect = parent.getBoundingClientRect();
      const parentViewableArea = { height: parent.clientHeight, width: parent.clientWidth };
      const childRect = child.getBoundingClientRect();
      const isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);
      if (!isViewable) {
        const scrollTop = childRect.top - parentRect.top;
        const scrollBot = childRect.bottom - parentRect.bottom;
        if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
          parent.scrollTop += scrollTop;
        } else {
          parent.scrollTop += scrollBot;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.items-block {
  min-height: 500px;
  border-bottom: 1px solid #DDD;
}

.item-list {
  max-height: 500px;
  overflow-y: auto;
}

.item {
  transition: background-color 0.3s;
  background-color: #FFF;
  padding: 10px 15px 10px 10px;
  min-height: 115px;
  border-bottom: 1px solid #DDD;

  &:hover {
    background-color: #F5F5F5;
  }

  &--active,
  &--active:hover {
    background-color: #DDD;
  }

  &:last-child {
    border-bottom: none;
  }

  &__address {
    font-size: 14px;
  }

  &__phone {
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
  }
}

.summary {
  padding: 10px;
  border-bottom: 1px solid #DDD;
  font-size: 14px;
  background-color: transparent;
}

.map-container {
  width: 100%;
  height: 100%;
  border-left: 1px solid #DDD;
}

.map-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 500px;
}

.show-all {
  position: absolute;
  z-index: 2;
  background-color: #FFF;
  padding: 8px 10px;
  top: 10px;
  right: 60px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  cursor: pointer;
  color: #eb3a43;
  font-weight: 600;
}

@media (max-width: 768px) {
  .item-list-wrap {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }

  .item-list {
    max-height: none;
    overflow-y: visible;

  }

  .item {
    text-align: center;
    padding: 10px 0;

    &--active {
      background-color: #FFF;

      &:hover {
        background-color: #F5F5F5;
      }
    }

    &__title {
      font-size: 18px;
      margin-bottom: 6px;
      text-transform: uppercase;
    }

    &__address {
      font-size: 16px;
      margin-bottom: 12px;
      padding: 0 48px;
    }

    &__btn {
      color: #FFF;
      font-size: 18px;
      font-weight: 600;

      span {
        margin-right: 10px;
      }
    }
  }
}
</style>